import { forwardRef } from 'react';
import '../style/Nav.scss';
import { GraduationCap, Home, Library, User } from 'lucide-react';

const Nav = forwardRef(({ activePage, setActivePage, hidden }, ref) => {

  const handleClick = (e) => {
    e.preventDefault();
    const option = e.currentTarget.className.split(' ')[0];

    // For home, scroll container to top instead of using scrollIntoView
    if (option === 'hero') {
      const container = document.querySelector('.infoContainerInner');
      if (container) {
        container.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return;
    }

    const element = document.getElementById(option);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className={`navLinks ${hidden ? 'hidden' : ''}`} ref={ref}>
      <button className="hero navLink" onClick={handleClick}>
        <Home />
        <span>Home</span>
      </button>
      <button className="about navLink" onClick={handleClick}>
        <User />
        <span>About</span>
      </button>
      <button className="education navLink" onClick={handleClick}>
        <GraduationCap />
        <span>Education</span>
      </button>
      <button className="projects navLink" onClick={handleClick}>
        <Library />
        <span>Projects</span>
      </button>
    </div>
  );
});

export default Nav;
